import {
  Component,
  effect,
  EventEmitter,
  HostListener,
  input,
  InputSignal,
  OnInit,
  Output,
} from '@angular/core';
import { Column, ColumnType, SelectedItem } from './models/simple-table-model';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { ActionButton } from '../../models/action-button.model';
import { trackByFn } from '../../functions/track-by-id';
@Component({
  selector: 'app-simple-table',
  templateUrl: './simple-table.component.html',
  styleUrls: ['./simple-table.component.scss'],
})
export class SimpleTableComponent implements OnInit {
  readonly DISABLED_SUFFIX = 'Disabled';
  readonly MOBILE_SCREEN_ZISE = 768;
  readonly trackByFn = trackByFn;

  readonly columns: InputSignal<Column[]> = input<Column[]>();
  readonly actions: InputSignal<ActionButton[]> = input<ActionButton[]>();
  readonly isAdvancedColumns: InputSignal<boolean> = input<boolean>();
  readonly allowSelection: InputSignal<boolean> = input<boolean>();
  readonly selectedItems: InputSignal<SelectedItem[]> = input<SelectedItem[]>();
  readonly items: InputSignal<any[]> = input<any[]>();

  selectedCheckboxes: number[] = [];

  @Output()
  selectionChange: EventEmitter<SelectedItem[]> = new EventEmitter();

  @Output()
  action: EventEmitter<ActionButton> = new EventEmitter();

  data: any[] = [];

  columnType = ColumnType;
  isMobile: boolean;

  constructor() {
    effect(() => {
      this.selectedCheckboxes = JSON.parse(
        JSON.stringify(this.selectedItems()?.map((item) => item.id) || [])
      );

      if (this.allowSelection) {
        this.items()?.forEach((dataItem) => {
          const dataSelected = this.selectedCheckboxes.find(
            (item) => item === dataItem.id
          );
          if (dataSelected) {
            dataItem.selected = true;
          }
        });
      }
      this.data = this.items();
    });
  }

  ngOnInit(): void {
    this.isMobileVerification();
  }

  changeAllCheckboxes(change: MatCheckboxChange): void {
    this.data.forEach((data) => (data.selected = change.checked));
    this.verifySelectedCheckboxes();
  }

  verifySelectedCheckboxes(): void {
    const selections: number[] = [];
    this.data.forEach((rowValue) => {
      if (rowValue.selected && !this.selectedCheckboxes.includes(rowValue.id)) {
        selections.push(rowValue.id);
      }

      if (!rowValue.selected && this.selectedCheckboxes.includes(rowValue.id)) {
        const uncheckedIndex = this.selectedCheckboxes.indexOf(rowValue.id);
        this.selectedCheckboxes.splice(uncheckedIndex, 1);
      }
    });

    const selectedItems = [...selections, ...this.selectedCheckboxes];
    const selectedItemsBuilded = Array.from(
      new Set(selectedItems.map((item) => ({ id: item })))
    );

    this.selectionChange.emit(selectedItemsBuilded);
  }

  emitAction(action: ActionButton, index: number): void {
    action.index = index;
    this.action.emit(action);
  }

  @HostListener('window:resize')
  onResize() {
    this.isMobileVerification();
  }

  isMobileVerification(): void {
    this.isMobile = window.innerWidth <= this.MOBILE_SCREEN_ZISE;
  }
}
